import { FileUploader } from "react-drag-drop-files";
import { alertError } from "../../../utilities/alerts.utilities";
import "./fileUpload.css";
const FileUpload = ({
  fileTypes,
  handleChange,
  isMulti = true,
  maxSize = 4,
}) => {
  return (
    <FileUploader
      multiple={isMulti}
      handleChange={handleChange}
      name="file"
      onTypeError={(e) => alertError("Solo se permiten los tipos de datos "+ fileTypes)}
      onSizeError={(e) => alertError(`máximo peso permitido es ${maxSize} mb`)}
      types={fileTypes}
      label={"Suba o arrastre archivos justo aquí"}
      styles={{maxWith:"100px"}}
      hoverTitle={"Suelte aquí"}
      classes={"drop_area_upload_file"}
      maxSize={maxSize}
    />
  );
};

export default FileUpload;
